import { LayerType } from '@/views/map/layers/types';
import { useSmallScreen } from '@/hooks/useWindowDimension';
import { TreeTypeLegend } from './TreeTypeLegend';
import type { SelectionProps } from './MapLayerOption';
import { MapLayerOption } from './MapLayerOption';

export const TreeTypeLayerOption = (props: SelectionProps) => {
  const isSmallScreen = useSmallScreen();

  return (
    <MapLayerOption
      title="By tree type"
      value={LayerType[LayerType.tree_type]}
      {...props}
    >
      {isSmallScreen && props.selected === LayerType[LayerType.tree_type] && (
        <TreeTypeLegend />
      )}
    </MapLayerOption>
  );
};
